// extracted by mini-css-extract-plugin
export default {"fullscreen":"ChartWrapper_fullscreen__Xqj4L"};